<template>
  <div v-if="showComponent && onReady" :key="componentRefresh" :id="`ks-data-grid-${_uid}`">
    <div>
      <h5 v-if="title">{{ title }}</h5>
      <div class="d-flex flex-row justify-content-between" style="width: 100%; margin-bottom: 7px;">
        <ks-data-mode-selector v-if="modesConfiguration.enable"
          style="width: 90vh;"
          :dataProvider="dataProvider"
          :defaultModeName="modesConfiguration.defaultModeName"
          :submitOnChangeForm="modesConfiguration.submitOnChangeForm"
        />
        <span v-if="showFilter">
          <input type="text" 
            class="form-control"
            v-on:keyup="filter()"
            v-model="filter_text"
            placeholder="Filter..."
            autocomplete="new-password"
          />
        </span>
        <div style="width: 100%;" class="d-flex justify-content-end">
          <div class="dropdown mr-2" v-if="columnHiddenEnable && activeViewType=='table'">
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-eye fa-fw"></i>
            </button>
            <div class="dropdown-menu" :id="`ks-grid-column-hidden-menu-${_uid}`">
              <template v-for="column of columns">
                <a class="dropdown-item" :class="[{'text-muted':column.isHidden, 'text-dark':!column.isHidden }]"
                   @click.prevent="column.hidden()" :key="'column-'+column.dataSource">
                  <template v-if="column.iconClass && column.iconClass.length>0">
                    <i :class="column.iconClass"></i>
                  </template>
                  <template v-else>
                    {{ column.label || column.title || column.dataSource }}
                  </template>
                  <span style="float:right;font-size: 0.75rem;" v-show="column.isHidden"><i class="fa fa-eye-slash"></i></span>
                  <span style="float:right;font-size: 0.75rem;" v-show="!column.isHidden"><i class="fa fa-eye"></i></span>
                </a>
              </template>
            </div>
          </div>

          <div class="dropdown float-right" v-if="avalibleViewTypes.length > 0">
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="activeViewType=='table'">
              <i class="fas fa-bars fa-fw"></i>
            </button>
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="activeViewType=='gallery'">
              <i class="fas fa-th fa-fw"></i>
            </button>
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="activeViewType=='grid'">
              <i class="fas fa-table fa-fw"></i>
            </button>
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="activeViewType=='map'">
              <i class="fas fa-map fa-fw"></i>
            </button>
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="activeViewType=='calendar'">
              <i class="far fa-calendar-alt fa-fw"></i>
            </button>
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="activeViewType=='chart-bar'">
              <i class="fas fa-chart-bar fa-fw"></i>
            </button>
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="activeViewType=='chart-pie'">
              <i class="fas fa-chart-pie fa-fw"></i>
            </button>
            <button class="btn btn-light btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="activeViewType=='chart-line'">
              <i class="fas fa-chart-line fa-fw"></i>
            </button>
            <div class="dropdown-menu" style="min-width:4rem;font-size:0.9rem">
              <a v-for="type in avalibleViewTypes"
                 class="dropdown-item"
                 @click.prevent="setActiveViewType(type)">
                <i :class="[{
                  'fas fa-bars fa-fw':type=='table',
                  'fas fa-th fa-fw':type=='gallery',
                  'fas fa-table fa-fw':type=='grid' ,
                  'fas fa-map fa-fw':type =='map',
                  'far fa-calendar-alt fa-fw':type == 'calendar',
                  'fas fa-chart-bar fa-fw':type == 'chart-bar',
                  'fas fa-chart-pie fa-fw':type == 'chart-pie',
                  'fas fa-chart-line fa-fw':type == 'chart-line'
                }]"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!loading">
      <table class="table" :class="{'table-hover': tableHover, [classes]: true}" v-if="activeViewType === 'table'">
        <thead @drop="dropHeader($event)" @dragover="allowDrop($event)">
        <tr v-if="autoHeaders">
          <ks-data-grid-header
              v-for="header in headers"
              :dataSource="header.dataSource"
              :iconClass="header.icon"
              :title="header.title"
              :sortable="header.sortable"
              :label="header.label"
          >
          </ks-data-grid-header>
        </tr>
        <slot name="header" v-else></slot>
        </thead>
        <tbody>
        <template
            v-if="(!resultSet ? data_provider_ref.list.length > 0 : (data_provider_ref.result.list[resultSet] ? data_provider_ref.result.list[resultSet].length > 0 : false)) || addNullOptionToList">
          <tr v-for="(row, idxRow) in !resultSet ? data_provider_ref.list : data_provider_ref.result.list[resultSet]"
              :id="'tr_' + row.id + '_' + idxRow" :key="'row' + idxRow"
              :class="{'table-active': idxRow === active_record, 'subrow': row[subfield], 'dragged-on':row.__draggedOn && !topHalf('tr_' + row.id + '_' + idxRow), 'dragged-on-top':row.__draggedOn && topHalf('tr_' + row.id + '_' + idxRow), 'small-row': smallRow}"
              @click="set_selected(row, idxRow)"
              @mouseover="set_hover_state(row, true)" @mouseleave="set_hover_state(row, false)"
              :draggable="draggable"
              @dragenter="dragEnter($event, row)"
              @dragstart="$emit('dragStart', row)"
              @dragend="$emit('dragEnd', row)"
              @dragleave="dragLeave($event, row)"
              @dragover="allowDrop($event)"
              @drop="drop($event, row, topHalf('tr_' + row.id + '_' + idxRow))"
              style="position: relative;"
          >
            <slot name="body" :row="row" :activeViewType="activeViewType" :index="idxRow"></slot>
          </tr>
        </template>
        <template v-else>
          <div v-if="!noRecordHtml">No records found</div>

          <div v-else v-html="noRecordHtml"></div>

        </template>
        </tbody>
      </table>

      <div v-if="activeViewType === 'grid'" class="d-flex flex-row justify-content-center flex-wrap">
        <div v-for="(row, idxRow) in !resultSet ? data_provider_ref.list : data_provider_ref.result.list[resultSet]"
             :key="'row' + idxRow" style="width: 350px" @mouseover="set_hover_state(row, true)"
             @mouseleave="set_hover_state(row, false)">
          <slot name="body" :row="row" :index="idxRow" :activeViewType="activeViewType"></slot>
        </div>
      </div>

      <div class="row text-center text-lg-left" v-if="activeViewType === 'gallery'">
        <slot v-for="(row, idxRow) in !resultSet ? data_provider_ref.list : data_provider_ref.result.list[resultSet]"
              name="gallery" :row="row" :index="idxRow" :activeViewType="activeViewType"></slot>
      </div>

      <div v-if="activeViewType === 'map'">
        <template v-if="map.apiKey">
          <ks-map
              :apiKey="map.apiKey"
              @click="mapEvents($event, 'click')"
              @zoom="mapEvents($event, 'zoom')"
              @dragend="mapEvents($event, 'dragend')"
              @onLoad="mapEvents($event, 'onLoad')"
              ref="map"
              style="height:500px"
              :markers="markers"
          />
        </template>
        <template v-else>
          <div class=text-muted>
            INVALID API KEY
          </div>
        </template>
      </div>

      <div v-if="activeViewType === 'calendar'">
        <ks-calendar
            @onNext="calendarEvents($event, 'next')"
            @onPrevious="calendarEvents($event, 'previous')"
            @onToday="calendarEvents($event, 'today')"
            @onMonth="calendarEvents($event, 'month')"
            @onClick="set_selected_calendar"
            @onMouseLeave="set_hover_state_calendar($event, false)"
            @onMouseOver="set_hover_state_calendar($event, true)"
            :showDate="calendar.showDate"
            :ref="`ks-data-grid-calendar-${_uid}`"
        >
          <template #content="{date}">
            <slot name="calendar"
                  :row="calendarData[date.format('YYYY-MM-DD')]?calendarData[date.format('YYYY-MM-DD')]:{}"
                  :date="date" :activeViewType="activeViewType">
            </slot>
          </template>
        </ks-calendar>
      </div>

      <div v-if="activeViewType === 'chart-bar' || activeViewType === 'chart-pie' || activeViewType === 'chart-line'">
        <ks-chart
            :width="chart.width"
            :height="chart.height"
            :configuration="{
              type: chartType,
              data: {
                labels: chart.labels,
                datasets: chartDatasets
              },
              maintainAspectRatio: true,
              responsive:true,
              options: {
                barValueSpacing: 1, // doesn't work; find another way
                barDatasetSpacing: 1, // doesn't work; find another way
              }
          }"/>
      </div>
    </div>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';
import onMountedDataProvider from '../../mixins/onMountedDataProvider';
import moment from 'moment'
import Vue from 'vue';

export default {
  /**
   tag
   name: ks-data-grid
   description: data grid component
   **/
  name: 'data-grid',
  mixins: [checkPermissions, onMountedDataProvider],
  computed: {
    hasSlotHeader() {
      return !!this.$slots.header;
    },
    hasSlotBody() {
      return !!this.$slots.body;
    },
    hasSlotFooter() {
      return !!this.$slots.footer;
    },
    chartType() {
      let aux = this.activeViewType.split("-");
      return aux[0] == 'chart' ? aux[1] : null;
    }
  },
  props: {
    autoHeaders: {
      type: Boolean,
      default: false
    },

    /**
     attribute
     name: smallRow
     description: set the row to 27px
     **/
    smallRow: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: gridViewWidth
     description: gridViewWidth
     **/
    gridViewWidth: {
      type: String,
      default: "350px"
    },
    /**
     attribute
     name: noRecordHtml
     description: noRecordHtml
     **/
    noRecordHtml: {
      type: String,
      default: null
    },
    /**
     attribute
     name: activeView
     description: activeView
     **/
    activeView: {
      type: String,
      default: 'table'//"table", "grid", "list/gallery" "map", "calendar", "chart-bar", "chart-pie", "chart-line"
    },
    /**
     attribute
     name: draggable
     description: draggable
     **/
    draggable: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: addNullOptionToList
     description: addNullOptionToList
     **/
    addNullOptionToList: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: calendar
     description: calendar
     **/
    calendar: {
      type: Object,
      default: () => {
        return {
          date: null,
          showDate: true
        }
      }
    },
    map: {
      type: Object,
      default: () => {
        return {
          searchOnDragControl: true,
          apiKey: null,
          title: null,
          lat: null,
          lng: null,
          click: null,
          defaultMarkers: [],
          icon: null,
          icons: {}
        }
      }
    },
    chart: {
      type: Object,
      default: () => {
        return {
          width: null,
          height: null,
          labels: [],
          datasets: {
            label: null,
            data: [], // name of colum
            //backgroundColor: null,
            //borderWidth: null //define border
          },
        }
      }
    },
    avalibleViewTypes: {
      type: Array,
      default: () => {
        return []//["table", "grid", "map", "calendar", "gallery(free)", "chart-bar", "chart-pie"]
      }
    },
    title: {
      type: String,
      default: null
    },
    dataProvider: {
      required: true,
      default: null
    },
    resultSet: {
      required: false,
      default: null
    },
    classes: {
      type: String,
      default: null
    },
    showFilter: {
      type: Boolean,
      default: false
    },
    subfield: {
      type: String,
      default: ''
    },
    tableHover: {
      type: Boolean,
      default: true
    },
    modeCodeId: {
      type: String,
      default: null
    },
    modesConfiguration: {
      type: Object,
      default: () => {
        return {
          'enable': false,
          'defaultModeName': null,
          'submitOnChangeForm': false
        }
      }
    },
    columnHiddenEnable: {
      type: Boolean,
      default: true
    },
    beforeViewTypeChange: {
      type: Function,
      default: null
    }
  },
  watch: {
    activeViewType: function (val, oldval) {
      if (oldval !== null) {
        this.$emit('onViewTypeChange', this);
      }
    },
    'activeView': function (val) {
      //this.activeViewType = val;
      this.setActiveViewType(val);
    },

    'data_provider_ref.loading': function (val) {
      this.loading = val /*&& (activeViewType === 'grid' || activeViewType === 'table')*/;
    },

    'data_provider_ref.list': {
      handler(newVal) {
        this.loadMap();
        this.loadCalendar();
        this.loadChart();
      },
      depp: true
    },
    'data_provider_ref.activeListRecordIndex': function (idx) {
      if (idx == null) {
        this.set_selected({}, null);
      } else {
        this.set_selected(!this.resultSet ? this.data_provider_ref.list[idx] : this.data_provider_ref.result.list[this.resultSet][idx], idx);
      }
    }
  },
  async mounted() {

    await this.onMountedDataProvider();

    $(document).on('click', `#ks-grid-column-hidden-menu-${this._uid}`, (e) => {
      e.stopPropagation();
    });

    app.dataGridComponent = this;
    //this.activeViewType = this.activeView;

    // register in mode components if modeCodeId is defined
    if (this.modeCodeId !== null) {
      if (typeof app["mode_components"] === 'undefined') {
        app["mode_components"] = [];
      }
      app["mode_components"].push({'codeId': this.modeCodeId, 'component': this});
    }

    let element = document.getElementById(`ks-data-grid-${this._uid}`);
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0, 1.0]
    };

    let handleIntersect = (entries, observer) => {
      let _this = this;
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          _this.$emit('onVisible', {'el': this, 'isVisible': true});
        } else if (entry.intersectionRatio === 0.0) {
          _this.$emit('onVisible', {'el': this, 'isVisible': false});
        }
      });
    }

    observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(element);

  },
  data() {
    return {
      headers: [],
      timers: {},
      counters: {},
      mouseY: null,
      active_record: null,
      filter_text: null,
      hovered: false,
      markers: [],
      calendarData: {},
      chartDatasets: [],
      activeViewType: this.activeView,
      searchOnDrag: true,
      columns: {},
      columnConfiguration: {},
      loading: false
    }
  },
  methods: {
    dragEnter(e, row) {
      let _this = this;
      this.counters[row.id] ? this.counters[row.id]++ : this.counters[row.id] = 1;
      //this.timers[row.id] = setTimeout(function() {
      _this.$emit('dragEnter', row, e);
      //}, 300);
    },
    async dragLeave(e, row) {
      let _this = this;
      _this.counters[row.id]--;
      if (_this.counters[row.id] === 0) {
        /*if (_this.timers[row.id]) {
          await clearTimeout(_this.timers[row.id]);
        }*/
        this.$emit('dragLeave', row, e)
      }
    },
    setMousePostion(e) {
      this.mouseY = e.pageY;
    },
    topHalf(id) {
      let top = $('#' + id).offset().top;
      let bottom = $('#' + id).offset().top + $('#' + id).height();
      let half = (bottom - top) / 2;
      let value = this.mouseY < (top + half);
      return value;
    },
    allowDrop(ev) {
      this.mouseY = ev.pageY;
      ev.preventDefault();
    },
    drop(ev, row, top) {
      ev.preventDefault();
      if (top) {
        this.$emit('droppedTop', row);
      } else {
        this.$emit('dropped', row);
      }
    },
    dropHeader(ev) {
      ev.preventDefault();
      this.$emit('droppedHeader');
    },
    set_hover_state(row, value) {
      Vue.set(row, '__hovered', value);
    },
    set_hover_state_calendar(evt, value) {
      if (this.calendarData[evt.date.format('YYYY-MM-DD')]) {
        Vue.set(this.calendarData[evt.date.format('YYYY-MM-DD')], '__hovered', value);
      }
    },
    set_selected_calendar(evt) {
      if (this.calendarData[evt.date.format('YYYY-MM-DD')]) {
        for (let key in this.calendarData) {
          if (this.calendarData[key].__selected) {
            this.calendarData[key].__selected = false;
            break;
          }
        }
        Vue.set(this.calendarData[evt.date.format('YYYY-MM-DD')], '__selected', true);
      }
    },
    set_selected(row = {}, idxRow = null) {
      this.active_record = idxRow;
      this.data_provider_ref.setSelectedListItemIndex(idxRow);
      let foundItem = !this.resultSet ? this.data_provider_ref.list.find(item => item.__selected) : this.data_provider_ref.result.list[this.resultSet].find(item => item.__selected);
      if (foundItem) foundItem.__selected = false;
      if (idxRow !== null) {
        Vue.set(row, '__selected', true);
        this.$emit('onRowClick', row);
      }
    },
    mapEvents(event, name) {
      switch (name) {
        case 'onLoad':
          if (this.map.searchOnDragControl) {
            let controlUI = document.createElement("div");
            controlUI.style.backgroundColor = "#fff";
            controlUI.style.border = "2px solid #fff";
            controlUI.style.borderRadius = "3px";
            controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
            controlUI.style.cursor = "pointer";
            controlUI.style.margin = "10px";
            controlUI.style.textAlign = "center";
            controlUI.title = "search on drag map";

            let checkContainer = document.createElement("label");
            checkContainer.className = "map-searchondrag-label";
            let checkInput = document.createElement("input");
            checkInput.type = "checkbox";
            checkInput.className = "map-searchondrag-checbox-control"
            checkInput.setAttribute("id", `checkSearchOnDrag_${this._uid}`);
            checkInput.setAttribute("checked", this.searchOnDrag);

            checkInput.addEventListener('change', (e) => {
              this.searchOnDrag = e.target.checked;
            }, false);

            let checkLabel = document.createElement("label");
            checkLabel.className = "map-searchondrag-checbox-label"
            checkLabel.setAttribute("for", `checkSearchOnDrag_${this._uid}`);
            checkLabel.innerHTML = "Search on Drag";
            checkContainer.appendChild(checkInput);
            checkContainer.appendChild(checkLabel);
            controlUI.appendChild(checkContainer);
            event.map.controls[google.maps.ControlPosition.TOP_LEFT].push(controlUI);
          }
          break;
        default:
          break;
      }
      this.$emit('mapEvent', {event: event, name: name, enableSearchOnDrag: this.searchOnDrag});
    },
    loadMap() {
      try {
        this.markers = [];
        let icons = typeof this.map.icons !== 'undefined' && this.map.icons !== {} ? this.map.icons : undefined;
        if (this.map.apiKey) {
          if (this.map.lat && this.map.lng) {
            for (let row of !this.resultSet ? this.data_provider_ref.list : this.data_provider_ref.result.list[this.resultSet]) {
              if (row[this.map.lat] && row[this.map.lng]) {
                let icon = icons && this.map.icon ? (typeof row[this.map.icon] !== 'undefined' ? typeof icons[row[this.map.icon]] !== 'undefined' : icons[this.map.icon]) : undefined;
                this.markers.push({
                  title: this.map.title && row[this.map.title] ? row[this.map.title] : null,
                  lat: row[this.map.lat],
                  lng: row[this.map.lng],
                  click: row[this.map.click] ? row[this.map.click] : null,
                  icon: icon
                })
              }
            }
          } else if (this.map.defaultMarkers && this.map.defaultMarkers.length > 0) {
            this.markers = this.map.defaultMarkers;
          }
        }
      } catch (err) {
        console.log('KS-APP: ', err);
      }
    },
    loadChart() {
      try {
        let datasets = [];
        if (Array.isArray(this.chart.datasets.data) && this.chart.datasets.data.length > 0) {
          let list = !this.resultSet ? this.data_provider_ref.list : this.data_provider_ref.result.list[this.resultSet];
          for (let [iRow, row] of list.entries()) {
            let data = [];
            for (let ds of this.chart.datasets.data) {
              data.push(row[ds] ? row[ds] : null);
            }
            datasets.push({
              label: row[this.chart.datasets.label] ? row[this.chart.datasets.label] : this.chart.datasets.label,
              data: data,
              backgroundColor: `rgba(${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)},${Math.floor(Math.random() * 256)}, 1)`,
              fill: false,
              borderWidth: this.chart.datasets.borderWidth ? this.chart.datasets.borderWidth : 1
            })
          }
        }
        this.chartDatasets = datasets;
      } catch (err) {
        console.log('KS-APP: ', err);
      }
    },
    calendarEvents(event, name) {
      this.$emit('calendarEvent', {event: event, name: name})
    },
    loadCalendar() {
      try {
        this.calendarData = {};
        if (this.calendar.date) {
          let data = !this.resultSet ? this.data_provider_ref.list : this.data_provider_ref.result.list[this.resultSet];
          let groupByDate = {};
          for (let row of data) {
            if (typeof row[this.calendar.date] !== 'undefined' && row[this.calendar.date] !== null && moment(row[this.calendar.date]).isValid()) {
              let date = moment(row[this.calendar.date]);
              if (typeof groupByDate[date.clone().format('YYYY-MM-DD')] === 'undefined') {
                groupByDate[date.clone().format('YYYY-MM-DD')] = {'data': [], '__hovered': false, '__selected': false};
              }
              groupByDate[date.clone().format('YYYY-MM-DD')].data.push({...row, '__date': date});
            }
          }
          this.calendarData = groupByDate;
        }
      } catch (err) {
        console.log('KS-APP: ', err);
      }
    },
    getComponentConfiguration() {
      switch (this.activeViewType) {
        case 'calendar':
          return {
            'activeViewType': this.activeViewType,
            'viewTypeConfiguration': this.$refs[`ks-data-grid-calendar-${this._uid}`].getComponentConfiguration()
          }
          break;
        default:
          let columnConfiguration = {};
          //get configuration for column headers
          for (let c in this.columns) {
            columnConfiguration[c] = this.columns[c].getComponentConfiguration();
          }
          return {
            'activeViewType': this.activeViewType,
            'columnConfiguration': columnConfiguration
          }
          break;
      }
    },
    setComponentConfiguration(config) {
      setTimeout(() => {
        this.columnConfiguration = {};
        for (let prop in config) {
          if (prop !== 'viewTypeConfiguration') {
            this[prop] = config[prop];
          }
        }
        if (config.columnConfiguration) {
          for (let c in config.columnConfiguration) {
            this.columns[c].setComponentConfiguration(c, config.columnConfiguration[c]);
          }
        } else {
          for (let c in this.columns) {
            this.columns[c].setComponentConfiguration(null, null, true);
          }
        }
        if (config.activeViewType === 'calendar') {
          this.$refs[`ks-data-grid-calendar-${this._uid}`].setComponentConfiguration(config.viewTypeConfiguration);
        }
      }, 1000);
    },
    columnHeaderEvent(evt, ref) {
      if (evt === 'hidden') {
        this.$set(this.columnConfiguration, ref.dataSource, {'isHidden': ref.isHidden});
      }
    },
    showColumn(column) {
      column.isHidden = false;
      this.columnConfiguration[column.dataSource]['isHidden'] = true;
    },
    async setActiveViewType(type) {
      try {
        //alert(type)
        if (this.beforeViewTypeChange !== null) await this.beforeViewTypeChange(this, type);
        this.activeViewType = type;
      } catch (err) {
        console.log(err);
      }
    }
  }
}
</script>
<style>
.full-width {
  width: 100%;
}

table {
  text-align: left;
  position: relative;
  border-collapse: collapse;
}

.map-searchondrag-label {
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: row-reverse;
  margin: 0;
}

.map-searchondrag-checbox-control {
  -webkit-box-align: center;
  align-items: center;
  box-sizing: border-box;
  width: 28px;
  height: 28px;
  margin: 4px;
  border-radius: 4px;
  border: 1px solid rgb(195, 199, 206);
  transition: background-color 0.15s ease-in-out 0s, border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  background-color: rgb(226, 231, 235);
  display: block;
  position: relative;
}

.map-searchondrag-checbox-label {
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  padding-top: 6px;
  padding-left: 4px;
  cursor: pointer;
  font-size: 16px;
  color: rgb(51, 63, 74);
  font-weight: bold;
}

th {
  padding: 0.25rem;
  background: white;
  position: sticky;
  top: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.active-view {
  background-color: #dddddd;
}

.subrow {
  background: #f7f7f7 !important;
}

.dragged-on {
  background: #D8EBFF !important;
}

.dragged-on-top {
  background-image: linear-gradient(#007bff, white, white, white);
}

.small-row {
  height: 27px !important;
  max-height: 27px !important;
  min-height: 27px !important;
}
</style>
